import { CONSTANTS } from "../../config";
import { REDUX_CONSTANTS } from "../reduxConstants";
import { startLoaderAction, stopLoaderAction } from "./LoaderAction";
import axios from "axios";

const updateCurrentLocationData = (payload) => {
    return {
        type: REDUX_CONSTANTS.UPDATE_CURRENT_LOCATION,
        payload: payload
    };
};

const updateSelectedLocationData = (payload) => {
    return {
        type: REDUX_CONSTANTS.UPDATE_SELECTED_LOCATION,
        payload: payload
    };
};

export const getLocationByLongAndLat = (long, lat, isCurrentLocation) => {
    return function (dispatch) {
        dispatch(startLoaderAction());

        let url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${long}&appid=${CONSTANTS.API_KEY}`;
        axios.get(url).then((response) => {
            console.log(response);
            if (isCurrentLocation) dispatch(updateCurrentLocationData(response.data));
            else dispatch(updateSelectedLocationData(response.data));
        }).catch((error) => {
            console.log(error);
        });

        dispatch(stopLoaderAction());

        dispatch(getForecastByLongAndLat(long, lat));
    };
};

export const getLocationByCityName = (cityName) => {
    return function (dispatch) {
        dispatch(startLoaderAction());

        let url = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${CONSTANTS.API_KEY}`;
        axios.get(url).then((response) => {
            // console.log("before", response.data.weather)

            // response.data.weather.forEach(item => {
            //     item.icon = item.icon.substring(0, item.icon.length - 1)
            // })
            // console.log("after:", response.data.weather)
            dispatch(updateCurrentLocationData(response.data));
        }).catch((error) => {
            console.log(error);
            dispatch({ type: REDUX_CONSTANTS.UPDATE_TOAST, payload: true });
        });

        dispatch(stopLoaderAction());

        dispatch(getForecastByCityName(cityName));
    };
};

export const getForecastByCityName = (cityName) => {
    return function (dispatch) {
        dispatch(startLoaderAction());
        let url = `https://api.openweathermap.org/data/2.5/forecast?q=${cityName}&appid=${CONSTANTS.API_KEY}`;
        axios.get(url).then((response) => {
            dispatch({ type: REDUX_CONSTANTS.UPDATE_FORECAST_DATA, payload: response.data });
        }).catch((error) => {
            console.log(error);
        });
        dispatch(stopLoaderAction());
    };
};

export const getForecastByLongAndLat = (long, lat) => {
    return function (dispatch) {
        dispatch(startLoaderAction());
        let url = `https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${long}&appid=${CONSTANTS.API_KEY}`;
        axios.get(url).then((response) => {
            dispatch({ type: REDUX_CONSTANTS.UPDATE_FORECAST_DATA, payload: response.data });
        }).catch((error) => {
            console.log(error);
        });
        dispatch(stopLoaderAction());
    };
};

export const getCitiesList = () => {
    return function (dispatch) {
        dispatch(startLoaderAction());
        let url = 'https://countriesnow.space/api/v0.1/countries/cities';
        axios.post(url, {
            "country": "India",
        }).then((response) => {
            let updatedResponse = [];
            response.data.data.forEach(item => {
                updatedResponse.push({ label: item, value: item });
            });
            dispatch({ type: REDUX_CONSTANTS.UPDATE_CITIES_LIST, payload: updatedResponse });
            // dispatch({ type: REDUX_CONSTANTS.FILTER_CITIES_LIST, payload: updatedResponse.slice(0, 10) });
        }).catch((error) => {
            console.log(error);
        });
        dispatch(stopLoaderAction());
    };
};

// export const geticonByIconCode = (iconCode) => {
//     return function (dispatch) {
//         dispatch(startLoaderAction());

//         let url = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${CONSTANTS.API_KEY}`;
//         axios.get(url).then((response) => {
//             dispatch(updateSelectedLocationData(response.data));
//         }).catch((error) => {
//             console.log(error);
//         });

//         dispatch(stopLoaderAction());
//     };
// };